import RequredGoal from './component'
export default RequredGoal
